import { clearMessages, createErrorMessages, createSuccessMessages, messagesReceived } from "./message";

import { TYPE_KEY } from "../common/constant";
import rest from "../common/rest";
import ObjectUtils, { getEndTimeFromYear, getStartTimeFromYear } from "../utils/ObjectUtils";

import {
  REPORT_ACTIVATION
} from "../common/constant";
import { loadOverview } from "./respondentsOverview";

const { getDeepProperty } = ObjectUtils;

export const PERIOD_START = "periodStart";
export const PERIOD_END = "periodEnd";
export const CURRENT_YEAR = "currentYear";
export const TEMPLATE_IDENTIFIER = "templateIdentifier";
export const TEMPLATE_VERSION = "templateVersion";
export const PROGRAM_ID = "programId";

const SET_PERIOD = "REPORT_ACTIVATION.SET_PERIOD";
const SET_REPORT = "REPORT_ACTIVATION.SET_REPORT";

let currentYear = new Date().getFullYear();
let begin = getStartTimeFromYear(currentYear);
let end = getEndTimeFromYear(currentYear);

const initialState = {
  [CURRENT_YEAR]: currentYear,
  [PERIOD_START]: begin,
  [PERIOD_END]: end,
};

export default function reducer(state = initialState, action) {
  let newState;

  switch (action[TYPE_KEY]) {
    case SET_PERIOD:
      newState = Object.assign({}, state, {
        [PERIOD_START]: action[PERIOD_START],
        [PERIOD_END]: action[PERIOD_END],
        [CURRENT_YEAR]: action[CURRENT_YEAR]
      });
      break;

    case SET_REPORT:
      newState = Object.assign({}, state, {
        [TEMPLATE_IDENTIFIER]: action[TEMPLATE_IDENTIFIER],
        [TEMPLATE_VERSION]: action[TEMPLATE_VERSION],
        [PROGRAM_ID]: action[PROGRAM_ID]
      });
      break;

    default:
      newState = Object.assign({}, state, {});
      break;
  }

  return newState;
}

export const setPeriod = (periodStart, periodEnd, year) => {
  return {
    [TYPE_KEY]: SET_PERIOD,
    [PERIOD_START]: periodStart,
    [PERIOD_END]: periodEnd,
    [CURRENT_YEAR]: year
  };
};

export const setReport = (identifier, version, programId) => {
  return {
    [TYPE_KEY]: SET_REPORT,
    [TEMPLATE_IDENTIFIER]: identifier,
    [TEMPLATE_VERSION]: version,
    [PROGRAM_ID]: programId
  };
};

export const activation = (projectId, close) => {
  return (dispatch, getState) => {
    const identifier = getDeepProperty(getState(), REPORT_ACTIVATION, TEMPLATE_IDENTIFIER);
    const version = getDeepProperty(getState(), REPORT_ACTIVATION, TEMPLATE_VERSION);
    if (!identifier) {
      dispatch(messagesReceived(createErrorMessages("respondents.overview.report.activation.template_must_be_choosen")));
      return;
    }

    let payload = {
      periodStart: getDeepProperty(getState(), REPORT_ACTIVATION, PERIOD_START),
      periodEnd: getDeepProperty(getState(), REPORT_ACTIVATION, PERIOD_END),
      programId: getDeepProperty(getState(), REPORT_ACTIVATION, PROGRAM_ID),
      projectId
    };

    const url = `/admin/publish/survey/${identifier}/version/${version}`;
    rest.doPost(url, JSON.stringify(payload)).then(
      (result) => {
        if (result) {
          dispatch(clearMessages());
          close();
          if(result.isPublished){
            dispatch(loadOverview())
            dispatch(messagesReceived(createSuccessMessages("respondents.overview.report.activation.succeeded")));
          } else {
            dispatch(messagesReceived(createErrorMessages("respondents.overview.report.activation.not_published")));
          }
        } else {
          dispatch(messagesReceived(createErrorMessages("respondents.overview.report.activation.invalid")));
        }
      },
      () => {
        dispatch(messagesReceived(createErrorMessages("respondents.overview.report.activation.invalid")));
      }
    );
  };
};
